/* 4–8 weekly planner editor. Lives inside the Home settings panel; reuses
 * settingsForm.module.css for section/field/button chrome and adds the
 * subject-list controls + the Mon–Fri planning grid here. */

.planner {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

/* ---------- Subjects manager ---------- */

.subjectInput {
  flex: 1;
  min-width: 0;
}

.subjectControls {
  display: flex;
  gap: 6px;
  flex-shrink: 0;
}

/* ---------- Weekly grid ---------- */

.weekHead {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
}

.weekNav {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* Horizontal scroll guard for narrow settings panels — the 6-column grid can
 * exceed the panel width; let it scroll rather than squashing the inputs. */
.gridScroll {
  overflow-x: auto;
  margin-top: 8px;
}

.grid {
  display: grid;
  gap: 6px;
  min-width: 640px;
}

.cell {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.cornerCell {
  font-family: var(--token-font-display);
  font-size: 14px;
  color: var(--token-text-primary);
  align-self: end;
  padding-bottom: 6px;
}

.dayHead {
  align-items: center;
  text-align: center;
  gap: 1px;
  padding-bottom: 4px;
}

.dayName {
  font-family: var(--token-font-ui);
  font-weight: 700;
  font-size: 13px;
  color: var(--token-text-primary);
}

.dayDate {
  font-size: 11px;
  color: rgba(28, 38, 32, 0.55);
}

.rowLabel {
  justify-content: center;
  font-family: var(--token-font-ui);
  font-weight: 600;
  font-size: 13px;
  color: var(--token-text-primary);
  padding-right: 8px;
}

.todoLabel {
  align-self: start;
  padding-top: 8px;
}

.cellInput {
  width: 100%;
  box-sizing: border-box;
  padding: 7px 9px;
  border-radius: 8px;
  border: 1px solid rgba(8, 18, 12, 0.16);
  background: rgba(255, 255, 255, 0.75);
  font-family: var(--token-font-ui);
  font-size: 13px;
  color: var(--token-text-primary);
}

.cellTextarea {
  width: 100%;
  box-sizing: border-box;
  padding: 7px 9px;
  border-radius: 8px;
  border: 1px solid rgba(8, 18, 12, 0.16);
  background: rgba(255, 255, 255, 0.75);
  font-family: var(--token-font-ui);
  font-size: 13px;
  line-height: 1.4;
  color: var(--token-text-primary);
  resize: vertical;
}

.cellInput:focus,
.cellTextarea:focus {
  outline: 2px solid color-mix(in srgb, var(--token-accent) 55%, transparent);
  outline-offset: -1px;
  border-color: var(--token-accent);
}
